import { Box, Button, Stack, Typography } from '@mui/material'
import React from 'react'
import type { FallbackProps } from 'react-error-boundary'
import { useIntl } from 'react-intl'

import LinkButton from '@app/src/components/LinkButton'
import sentryService from '@app/src/services/SentryService'

export const logError = (error: Error, info: { componentStack: string }): void => {
  sentryService.captureError(error, {
    tags: {
      errorType: 'react-boundary',
      component: 'global-error-boundary',
    },
    extra: {
      componentStack: info.componentStack,
      errorInfo: info,
    },
    level: 'error',
  })

  console.error('%cOoops, seems like there was a serious issue: ', 'color: red; font-size: 18px')
  console.error(error)
  console.error(info.componentStack)
}

const GlobalError = ({ resetErrorBoundary }: FallbackProps): JSX.Element => {
  const { formatMessage } = useIntl()

  return (
    <Box height="100vh" display="flex" alignItems="center" justifyContent="center" bgcolor="grey.100">
      <Stack spacing={2} bgcolor="background.paper" p={4} borderRadius="8px">
        <Typography variant="h1">{formatMessage({ id: 'general.oops' })}</Typography>
        <Typography variant="body1">{formatMessage({ id: 'general.somethingWentWrong' })}</Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" onClick={resetErrorBoundary}>
            {formatMessage({ id: 'general.tryAgain' })}
          </Button>
          <LinkButton variant="outlined" to="/">
            {formatMessage({ id: 'general.letsGoBack' })}
          </LinkButton>
        </Stack>
      </Stack>
    </Box>
  )
}

export default GlobalError
